<template>
    <module-chart-with-options
        v-if="chartConfig"
        :chartConfig="chartConfig"
        :blocked-actions="NON_USER_DASHBOARD_BLOCKED_ACTIONS"
        hide-date
        no-pushes
        is-modal
        display-options-top
    />
</template>

<script setup lang="ts">
import { drilldownApi } from '@/api/powerMarkets/drilldownApi.ts';
import { IModuleChartConfig } from '@/interfaces/powerMarkets/charts/IModuleChartConfig.ts';
import { ref } from 'vue';
import { NON_USER_DASHBOARD_BLOCKED_ACTIONS } from '@/interfaces/actions/enact/IModuleActions.ts';
import ModuleChartWithOptions from '../chart/ModuleChartWithOptions.vue';

const props = defineProps<{
    id: string;
    fromDate: Date;
    toDate: Date;
}>();

const chartConfig = ref<IModuleChartConfig | null>(null);

async function getData (): Promise<void> {
    const country = props.id.split('&')[0].toLowerCase();
    const config = await drilldownApi.getChartAggregateSlideOut(props.id, country);

    chartConfig.value = {
        info: {
            name: '',
            date: {
                from: { type: 'date', value: props.fromDate },
                to: { type: 'date', value: props.toDate },
            },
            id: '',
            size: 'Medium',
        },

        data: config.data,
    };
}

getData();
</script>
